<div class="document-settings-header">
  <h3 class="document-settings-headline font-2xl">
    {{ "features.document-settings-modal.headline" | translate }}
  </h3>
  <button
    type="button"
    (click)="handleSettingsCloseClick()"
    [title]="
      'pia.features.document-settings-modal.closeButtonLabel' | translate
    "
    class="close-button icon-only-button"
  >
    <claas-icon
      [iconId]="'006172'"
      [namespace]="'pia'"
      [size]="24"
      [alt]="''"
      [removeDefaultColor]="true"
    ></claas-icon>
  </button>
</div>
<section class="settings-group">
  <p class="document-settings-sub-headline font-xs">
    {{ "features.document-settings-modal.subHeadlinePrimary" | translate }}
  </p>
  <p class="document-settings-instructions font-xs">
    {{ "features.document-settings-modal.instructionsPrimary" | translate }}
  </p>
  <mat-form-field appearance="outline">
    <mat-label>{{
      "features.document-settings-modal.subHeadlinePrimary" | translate
    }}</mat-label>
    <mat-select
      (selectionChange)="handlePrimaryLanguageSelectChange($event)"
      multiple
      [value]="primarySelectedLanguageOptions()"
    >
      @for (
        primaryLanguageOption of primaryLanguageOptions();
        track primaryLanguageOption.key
      ) {
        <mat-option
          [value]="primaryLanguageOption.key"
          [disabled]="isOnlySelected(primaryLanguageOption.key)"
          >{{ primaryLanguageOption.text }}</mat-option
        >
      }
    </mat-select>
  </mat-form-field>
</section>

@if (!!secondaryLanguageOptions().length) {
  <section class="settings-group">
    <p class="document-settings-sub-headline font-xs">
      {{ "features.document-settings-modal.subHeadlineSecondary" | translate }}
    </p>
    <p class="document-settings-instructions font-xs">
      {{ "features.document-settings-modal.instructionsSecondary" | translate }}
    </p>
    <mat-form-field appearance="outline">
      <mat-label>{{
        "features.document-settings-modal.subHeadlineSecondary" | translate
      }}</mat-label>
      <mat-select
        (selectionChange)="handleSecondaryLanguageSelectChange($event)"
        multiple
        [value]="secondarySelectedLanguageOptions()"
      >
        @for (
          secondaryLanguageOption of secondaryLanguageOptions();
          track secondaryLanguageOption.key
        ) {
          <mat-option [value]="secondaryLanguageOption.key">{{
            secondaryLanguageOption.text
          }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </section>
}

<section class="settings-group document-settings">
  <p class="document-settings-sub-headline font-xs">
    {{
      "features.document-settings-modal.subHeadlineAdditionalDocumentSettings"
        | translate
    }}
  </p>
  <p class="document-settings-instructions font-xs">
    {{
      "features.document-settings-modal.instructionsAdditionalDocumentSettings"
        | translate
    }}
  </p>
  <div class="toggle-button-wrapper">
    <claas-toggle
      id="toggle-button"
      [disabled]="false"
      [label]="'pia.shared.toggleDocumentIDLabel' | translate"
      [checked]="isChecked()"
      [required]="false"
      [disableRipple]="true"
      [inputTop]="false"
      [truncatedText]="true"
      (changed)="toggleDocumentID($event)"
    ></claas-toggle>
  </div>
</section>

<section class="settings-group contact-group">
  <a
    (click)="navigateTo()"
    [href]="`/pia/${this.countryID()}/${this.languageID()}/2026/contacts`"
    class="link button-support-contacts font-xs"
  >
    <claas-icon
      [id]="'technical-support'"
      [iconId]="'795311'"
      [namespace]="'storybook'"
      [iconStyle]="'bold'"
      [size]="24"
      [alt]=""
      [iconName]="'795311_support'"
      [removeDefaultColor]="false"
    ></claas-icon
    >{{
      "features.document-settings-modal.supportContactsButtonLabel" | translate
    }}
  </a>
</section>
